import React from 'react'
import { shape, string } from 'prop-types'
import IframeCarousel from '../../Primitive/IframeCarousel'

const GenericCarousel = ({ items }) => {
  return <IframeCarousel items={items} />
}

GenericCarousel.propTypes = {
  items: shape({
    title: string,
    iframeSrc: string
  })
}

export default GenericCarousel
